import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";

import SlackOAuthPage from "@/pages/slack/SlackOAuthPage";

const searchSchema = z.object({
  code: z.coerce.string(),
  state: z.coerce.string(),
});

export const Route = createFileRoute("/_secure/slack/oauth")({
  validateSearch: zodValidator(searchSchema),
  component: SlackOAuthPage,
});
